module.exports = __webpack_public_path__ + "img/x16.5c9af5bf.jpg";